<template>
  <BrandSwitchAnimator>
    <div class="app">
      <LoadingIndicator v-if="!brandSwitchAnimationIsActive" />

      <NuxtLayout>
        <NuxtRouteAnnouncer />
        <NuxtPage />
      </NuxtLayout>
    </div>
  </BrandSwitchAnimator>
</template>

<script setup lang="ts">
import { useCartStore } from '@@fire-b2b/stores/useCartStore'
import { useModalAcceptTerms } from '@fire-b2b/components/modals/composables/useModalAcceptTerms'

const { isActive: brandSwitchAnimationIsActive } = storeToRefs(useBrandSwitchAnimationStore())
const { clearTermsAcceptance } = useModalAcceptTerms()
const { resetCopyPasteData } = useCartStore()

const { loggedIn } = useAuth()
onMounted(() => {
  if (!loggedIn.value) {
    // delete terms acceptance if user logs out / on reload after logout
    clearTermsAcceptance()
    // reset cart copy paste data after logout to prevent showing old data on next login
    resetCopyPasteData()
  }
})

// TODO get maybe from config later?
window.addEventListener('contextmenu', function (e) {
  if ((e.target as HTMLElement).tagName === 'IMG') {
    e.preventDefault()
  }
})
</script>
